<template>
  <div id="cards-wrapper">
    <div id="cards">
      <div
        class="individual-card"
        v-for="(goal, index) in goalsStore"
        :key="index"
      >
        <div v-if="!goal.isHeader" class="cardName">
          <input
            type="text"
            placeholder="Collection name:"
            required
            maxlength="60"
            v-model="goal.name"
            @keyup.enter="setHeaderName(index)"
          />
          <button @click="setHeaderName(index)">Set</button>
        </div>
        <div v-if="goal.isHeader" class="individual-card-header">
          <header class="card-header">{{ goal.name.toUpperCase() }}</header>
          <button @click="removeCard(index)" class="removeCard">
            <img
              src="../../assets/delete.svg"
              alt="delete-icon"
              width="25"
              height="25"
            />
          </button>
          <section class="main-content-goals">
            <ul>
              <li v-for="(item, index2) in goal.items" :key="index2">
                {{ item }}
                <button @click="completed(index, index2)">&#10004;</button>
              </li>
            </ul>
          </section>
          <section>
            <input
              type="text"
              placeholder="Add another Goal:"
              v-model="goal.newItem"
              @keyup.enter="addGoal(index)"
            />
            <button @click="addGoal(index)">
              Add
            </button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    addGoal(index) {
      this.$store.commit("addGoal", { index: index });
    },
    setHeaderName(index) {
      this.$store.commit("setHeaderName", { index: index });
    },
    completed(index, index2) {
      this.$store.commit("completed", { index: index, index2: index2 });
    },
    removeCard(index) {
      this.$store.commit("removeCard", { index: index });
    },
  },
  computed: {
    goalsStore() {
      return this.$store.state.goals;
    },
  },
};
</script>
<style lang="scss" scoped>
#cards-wrapper {
  #cards {
    padding: 20px;
    text-align: center;
    .individual-card {
      margin: 20px;
      display: inline-table;
      background-color: #ebecf0;
      border-radius: 3px;
      color: darkblue;
      padding: 8px;
      width: 300px;
      max-width: 300px;
      box-shadow: 0 0 0.5vh darkgray;
      @media screen and (max-width: 1466px) {
        margin: 20px 10px;
      }
      @media screen and (max-width: 380px) {
        width: 260px;
        max-width: 260px;
      }
      @media screen and (max-width: 350px) {
        margin: 20px 0px;
      }
      .cardName {
        input[type="text"] {
          height: 25px;
          border: 2px solid slategray;
          padding-left: 2px;
          color: darkblue;
          font-weight: bold;
          &:focus {
            outline: none;
            border: 2px solid slateblue;
          }
          &::placeholder {
            font-size: 15px;
            margin-left: 2px;
            font-weight: normal;
          }
        }
        button {
          height: 29px;
          width: 40px;
          background-color: springgreen;
          color: rgb(44, 44, 44);
          border: 1px solid green;
          font-weight: 500;
          font-size: auto;
        }
      }
      section:nth-child(1) {
        font-size: 26px;
        text-align: center;
        text-shadow: 0.2px 0.2px 0.2px black;
      }
      .main-content-goals {
        width: 300px;
        margin: 16px 0px;
        @media screen and (max-width: 380px) {
          width: 260px;
        }
        ul {
          li {
            padding: 8px 4px;
            background-color: white;
            margin-bottom: 12px;
            border-radius: 4px;
            font-size: 16px;
            box-shadow: 0 0 2px gray;
            button {
              background-color: rgb(27, 132, 136);
              width: 20px;
              color: white;
              border: none;
              padding: 2px;
              &:hover {
                opacity: 0.8;
              }
            }
          }
          li:last-child {
            margin-bottom: 0px;
          }
        }
      }
      section:nth-child(4) {
        margin: 4px;
        input[type="text"] {
          border: none;
          outline: none;
          background-color: transparent;
          padding: 7.5px 4px;
          border-radius: 2px;
          width: auto;
          font-size: 15px;
          color: #222222;
          cursor: default;
          &:hover {
            box-shadow: 0 0 2px darkslateblue;
          }
          &:focus {
            box-shadow: 0 0 2px slateblue;
            cursor: initial;
          }
        }
        button {
          background-color: darkseagreen;
          width: 50px;
          border: 1px solid green;
          border-radius: 4px;
          color: white;
          height: 36px;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
  }
  #addCard {
    background-color: slateblue;
    color: white;
    font-weight: bold;
    border-radius: 8px;
    border: none;
    padding: 8px;
    font-size: 18px;
    &:hover {
      opacity: 0.9;
    }
    &:active {
      box-shadow: 0 0 2vh darkcyan;
    }
  }
}
.individual-card-header {
  width: 300px;
  @media screen and (max-width: 380px) {
    width: 260px;
  }
  .removeCard {
    margin-top: 4px;
  }
  header {
    width: 300px;
    font-weight: 500;
  }
}
</style>
